<template>
  <div :class="[error || serverError ? 'form-data__error' : '']" class="form-data">
    <div v-if="inputValue && inputValue.length > 0 && !serverError" class="upper-label">{{ label }}</div>
    <div v-if="serverError" class="upper-label upper-label__error">{{ errorLabel }}</div>

    <input
      v-model="inputValue"
      :placeholder="placeholder"
      :disabled="disable"
      type="text"
      @keyup="onKeyUp($event)"
      @blur="onBlurInput($event)"
    />

    <div :class="{ 'input-info__error': error }" class="input-info">{{ bottomInfo }}</div>
    <div class="error-input-info">{{ errorInfo }}</div>
    <div v-if="showSuggestions" class="suggestions">
      <ul>
        <li v-if="suggestions.length === 0">Нет данных</li>
        <li
          v-for="(suggest, index) in suggestions"
          :key="index"
          :class="{ 'active-suggest': suggest.lastChecked }"
          @click.stop="
            showSuggestions = false;
            typeof onClickSuggestionCallback === 'function'
              ? onClickSuggestionCallback(suggest, fieldname)
              : onClickSuggestion(suggest);
          "
        >
          {{ suggest.value }}
        </li>
      </ul>
    </div>
    <div v-if="onResetFormData" class="close-form-data" @click="onResetFormData" />
  </div>
</template>

<script>
import { mapActions } from "vuex";

import { getObjVal } from "../../common";
import isPlainObject from "lodash.isplainobject";

export default {
  name: "FormDadataAutocomplete",
  props: {
    error: {
      type: Boolean,
      default: false
    },
    disable: {
      type: Boolean,
      default: false
    },
    serverError: {
      type: Boolean,
      default: false
    },
    inputModel: {
      type: [String, Number, Array, Object],
      default: ""
    },
    fieldname: {
      type: [String, Array],
      default: ""
    },
    keymonitor: {
      type: Function,
      default: () => {}
    },
    update: {
      type: Function,
      default: () => {}
    },
    checkInput: {
      type: [Function, Boolean],
      default: false
    },
    onResetFormData: {
      type: [Function, Boolean],
      default: false
    },
    label: {
      type: String,
      default: ""
    },
    errorLabel: {
      type: String,
      default: ""
    },
    bottomInfo: {
      type: String,
      default: ""
    },
    errorInfo: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    },
    suggestFieldType: {
      type: String,
      default: ""
    },
    urlPart: {
      type: String,
      default: ""
    },
    fieldsToUpdate: {
      type: Array,
      default: () => []
    },
    listViewValueField: {
      type: String,
      default: () => []
    },
    // eslint-disable-next-line
    onClickSuggestionCallback: Function,
    params: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showSuggestions: false,
      keyUpInterval: null,
      suggestions: [],
      dadataFieldsMatchingMap: {
        name: "name.full",
        short_name: "name.short",
        inn: "inn",
        kpp: "kpp",
        ogrn: "ogrn",
        ogrnip: "ogrn",
        okved2: "okved",
        status: "state.status",
        closed_at: "state.liquidation_date",
        chief_name: "management.name",
        address: "address.value",
        location: "address.value",
        okved2_name: "name",
        okved2single: "kod"
      }
    };
  },
  computed: {
    inputValue: {
      get() {
        if (isPlainObject(this.inputModel)) {
          return this.inputModel.name;
        } else {
          return this.inputModel !== null ? this.inputModel.toString() : "";
        }
      },
      set(newValue) {
        this.$emit("update", { value: newValue, fieldname: this.fieldname });
      }
    }
  },
  created() {
    document.addEventListener("click", this.documentClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.documentClick);
  },
  methods: {
    ...mapActions(["getDadataInfo", "getSource"]),
    onKeyUp(event) {
      this.keymonitor(event);
      const value = event.target.value;

      if (event.keyCode === 40 || event.keyCode === 38) {
        if (this.suggestions.length > 0) {
          let lastIndex = this.suggestions.findIndex(s => s.lastChecked);
          if (lastIndex > -1) {
            if (lastIndex > this.suggestions.length && event.keyCode === 40) {
              lastIndex = 0;
            }
            if (lastIndex === 0 && event.keyCode === 38) {
              lastIndex = this.suggestions.length;
            }
            const action = event.keyCode === 38 ? lastIndex - 1 : lastIndex + 1;
            this.suggestions = this.suggestions.map((s, index) => {
              if (index === action) {
                s.lastChecked = true;
                return s;
              }
              s.lastChecked = false;
              return s;
            });
          } else {
            const active = event.keyCode === 38 ? this.suggestions.length - 1 : 0;
            this.suggestions = this.suggestions.map((s, index) => {
              if (index === active) {
                s.lastChecked = true;
                return s;
              }
              s.lastChecked = false;
              return s;
            });
          }
        }
        return;
      }

      if (event.keyCode === 39 || event.keyCode === 13) {
        const lastIndex = this.suggestions.findIndex(s => s.lastChecked);
        if (lastIndex > -1) {
          this.inputValue = this.suggestions[lastIndex].value;
        }
        if (event.keyCode === 13) {
          this.showSuggestions = false;
          typeof this.onClickSuggestionCallback === "function"
            ? this.onClickSuggestionCallback(this.suggestions[lastIndex])
            : this.onClickSuggestion(this.suggestions[lastIndex]);
        }
        return;
      }

      clearInterval(this.keyUpInterval);
      this.keyUpInterval = setInterval(() => {
        this.getDadataInfo({
          data: {
            query: value,
            params: this.params
          },
          urlPart: this.urlPart
        }).then(response => {
          if (response && response.status && response.status === 200 && response.data && response.data.suggestions) {
            this.showSuggestions = true;
            this.suggestions = response.data.suggestions;
          }
        });
        clearInterval(this.keyUpInterval);
      }, 500);
    },
    onClickSuggestion(suggest) {
      const data = suggest.data;
      const newData = {};

      this.fieldsToUpdate.forEach(field => {
        newData[field] = getObjVal(data, this.dadataFieldsMatchingMap[field]);
      });

      this.inputValue = getObjVal(suggest, this.listViewValueField);

      for (const field in newData) {
        if (field === "okved2single") {
          this.$emit("update", { value: newData["okved2single"], fieldname: `${this.fieldname.split(".")[0]}.okved2` });
        } else if (field === "status") {
          if (newData["status"] === "LIQUIDATED") {
            this.$emit("update", { value: "INACTIVE", fieldname: `${this.fieldname.split(".")[0]}.${field}` });
          }
        } else {
          this.$emit("update", { value: newData[field], fieldname: `${this.fieldname.split(".")[0]}.${field}` });
        }

        if (field === "okved2" || field === "okved2single") {
          this.getSource({
            url: "/api/dicts/okved2/",
            params: {
              code: newData["okved2"] || newData["okved2single"]
            }
          }).then(res => {
            res = res.data.results[0];
            if (res !== undefined && res.name) {
              this.$emit("update", { value: res.name, fieldname: `${this.fieldname.split(".")[0]}.okved2_name` });
            }
          });
        }

        if (field === "address" && data.address.data) {
          this.$emit("update", { value: data.address.data, fieldname: `${this.fieldname.split(".")[0]}.address_data` });
        }

        if (field === "location" && data.address.data) {
          this.$emit("update", { value: data.address.data, fieldname: `${this.fieldname.split(".")[0]}.location_data` });
          const lat = Number(data.address.data.geo_lat);
          const lng = Number(data.address.data.geo_lon);
          this.$emit("update", { value: { lat, lng }, fieldname: `${this.fieldname.split(".")[0]}.coordinates` });
        }
      }
    },
    documentClick() {
      this.showSuggestions = false;
    },
    onBlurInput(e) {
      this.$emit("blur", e);
    }
  }
};
</script>
